import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Eye, EyeOff } from "lucide-react";
import BreadCrumb from "Common/BreadCrumb";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { getUsername } from "Common/Components/getRoleId";

const UserProfile: React.FC = () => {
  const [showPassword, setShowPassword] = useState<{
    oldPassword: boolean;
    newPassword: boolean;
    confirmPassword: boolean;
  }>({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (
    field: "oldPassword" | "newPassword" | "confirmPassword"
  ) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };
  const token = localStorage.getItem("app_at_mahan");
  const username = getUsername(token);

  const user = {
    name: username,
    // email: "saeid.rezaei695@gmail.com",
    // role: username,
    oldPassword: "********",
  };

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("رمز قبلی الزامی است"),
      newPassword: Yup.string()
        .min(6, "رمز عبور باید حداقل ۶ کاراکتر باشد")
        .required("رمز عبور جدید الزامی است"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "رمز عبور تطابق ندارد")
        .required("تکرار رمز عبور الزامی است"),
    }),
    onSubmit: async (values) => {
      const token = localStorage.getItem("app_at_mahan");
      try {
        const newpasswordData = {
          old_password: values.oldPassword,
          new_password: values.newPassword,
          new_password_repeat: values.confirmPassword,
        };

        const res = await axios.post(
          "https://portal-api.mahanpanel.com/changepassword/",
          JSON.stringify(newpasswordData),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.status === 200) {
          toast.success("رمز عبور شما با موفقیت تغییر داده شد");
        }
      } catch (error: any) {
        console.log(error);
        toast.error("خطا در تغییر رمز عبور");
      }
    },
  });

  return (
    <>
      <ToastContainer
        position="top-center" // موقعیت وسط
        closeButton={false} // حذف دکمه بستن
        limit={1} // محدود کردن تعداد پیام‌ها
        className="font-Bold text-lg"
        rtl={true} // فعال کردن راست‌چین
      />
      <BreadCrumb title="سامانه ماهان پانل" pageTitle="تغییر رمز عبور" />
      <div className="max-w-md mx-auto mt-2 p-6 bg-gray-100 dark:bg-gray-700 shadow-xl rounded-xl">
        <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-white">
          پروفایل{" "}
        </h2>
        {/* اطلاعات کاربر */}
        <div className="mt-6 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
          <p className="text-gray-700 dark:text-gray-300">
            <strong>نام کاربری :</strong> {user.name}
          </p>
          <p className="text-gray-700 dark:text-gray-300">
            <strong>رمز عبور:</strong> {user.oldPassword}
          </p>
        </div>

        {/* فرم تغییر رمز عبور */}
        <div className="mt-6 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-4">
            تغییر رمز عبور
          </h3>

          <form onSubmit={formik.handleSubmit} className="space-y-4">
            {(["oldPassword", "newPassword", "confirmPassword"] as const).map(
              (field) => (
                <div key={field} className="relative">
                  <input
                    type={showPassword[field] ? "text" : "password"}
                    placeholder={
                      field === "oldPassword"
                        ? "رمز قبلی"
                        : field === "newPassword"
                          ? "رمز جدید"
                          : "تکرار رمز جدید"
                    }
                    {...formik.getFieldProps(field)}
                    className="w-full p-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility(field)}
                    className="absolute inset-y-0 left-3 flex items-center text-gray-500 dark:text-gray-300"
                  >
                    {showPassword[field] ? (
                      <EyeOff size={20} />
                    ) : (
                      <Eye size={20} />
                    )}
                  </button>
                  {formik.touched[field] && formik.errors[field] && (
                    <div className="text-red-500 text-sm">
                      {formik.errors[field]}
                    </div>
                  )}
                </div>
              )
            )}

            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-lg transition-all"
            >
              ذخیره تغییرات
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
